import React, { ReactElement } from 'react';
import useMobileMediaQuery from '../../../../hooks/useMobileMediaQuery';
import './ItinerarySidebarPlaceholder.scss';

function ItinerarySidebarPlaceholder(): ReactElement {
  const isMobile = useMobileMediaQuery();
  return (
    <div className='itinerary-sidebar-placeholder-container'>
      {isMobile ? (
        <div className='itinerary-sidebar-placeholder-text'>
          Create a list by clicking the &apos;+&apos; button above. Once created, a search bar will
          appear above the map for you to add places to your list!
        </div>
      ) : (
        <>
          <div className='itinerary-sidebar-placeholder-text'>
            Start by adding places you’re thinking of going to in the Playground tab.
          </div>
          <div className='itinerary-sidebar-placeholder-text'>
            You’ll see your lists and places saved here. To build your itinerary, drag and drop the
            cards from the lists. To remove cards from the itinerary, simply drag and drop the card
            away from the itinerary and back to its list.
          </div>
        </>
      )}
    </div>
  );
}

ItinerarySidebarPlaceholder.displayName = 'ItinerarySidebarPlaceholder';
export default ItinerarySidebarPlaceholder;
